/*jshint -W069 */
/**
 *
 * @class Api
 * @param {(string|object)} [domainOrOptions] - The project domain or options object. If object, see the object's optional properties.
 * @param {string} [domainOrOptions.domain] - The project domain
 * @param {object} [domainOrOptions.token] - auth token - object with value property and optional headerOrQueryName and isQuery properties
 */
var Api = (function() {
  'use strict';

  var Q = require('q');
  var settingsInstance = require('./SettingsInstance.js');
  var customRequest = require('./requestHelper.js').customRequest;
  var mergeQueryParams = require('./requestHelper.js').mergeQueryParams;

  function Api(options) {
    var domain = typeof options === 'object' ? options.domain : options;
    this.domain = domain ? domain : settingsInstance.baseApiNewUrl;
    if (this.domain.length === 0) {
      throw new Error('Domain parameter must be specified as a string.');
    }
  }

  /**
   * HTTP Request
   * @method
   * @name Api#request
   * @param {string} method - http method
   * @param {string} path - path
   * @param {string} url
   * @param {object} body - body parameters / object
   * @param {object} headers - header parameters
   * @param {object} queryParameters - querystring parameters
   * @param {object} form - form data object
   * @param {object} deferred - promise object
   */
  Api.prototype.request = customRequest;

  /**
   * Pobierz skale
   * @method
   * @name Api#getSkale
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.token - Token
   * @param {string} parameters.control - Parametr kontrolny
   */
  Api.prototype.getSkale = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/skale',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (parameters['control'] !== undefined) {
      queryParameters['control'] = parameters['control'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Dodaj skalę
   * @method
   * @name Api#postSkale
   * @param {object} parameters - method options and parameters
   * @param {} parameters.body -
   * @param {string} parameters.token - Token
   * @param {string} parameters.token - Token
   */
  Api.prototype.postSkale = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/skale',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['body'] !== undefined) {
      body = parameters['body'];
    }

    if (parameters['body'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: body'));
      return deferred.promise;
    }

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'POST',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Usuń skale
   * @method
   * @name Api#deleteSkaleById
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.id - ID skali
   * @param {string} parameters.token - Token
   */
  Api.prototype.deleteSkaleById = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/skale/{id}',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    parameterPath = parameterPath.replace('{id}', parameters['id']);

    if (parameters['id'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: id'));
      return deferred.promise;
    }

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'DELETE',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  return Api;
})();

exports.Api = Api;
